import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIModule } from "./ui/ui.module";
import { SendEmailPopupComponent, SharedComponents } from './components/components';
import { MaterialModule } from '../material.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditorModule } from '@tinymce/tinymce-angular';
import { DisplayColumnsPopupComponent } from './components/display-columns-popup/display-columns-popup.component';
import { StudentImportViaExcelComponent } from '../pages/wil/student-import-via-excel/student-import-via-excel.component';
import { IndustryPartnerImportViaExcelComponent } from '../pages/wil/industry-partner-import-via-excel/industry-partner-import-via-excel.component';
import { StudentFormModule } from './components/student/student-form/student-form.module';
import { EmployerStudentFormModule } from './components/employer/student-form/employer-student-form.module';
import { ViewProfileModule } from './components/employer/view-profile/view-profile.module';
import { StudentProfileComponent } from './components/student-profile/student-profile.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { QuillModule } from 'ngx-quill';
import { PreviewFormsComponent } from './components/preview-forms/preview-forms.component';
import { ViewEmailPopupComponent } from './components/view-email-popup/view-email-popup.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AutoResizeDirective } from '../auto-resize-height.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    ...SharedComponents,
    DisplayColumnsPopupComponent,
    SendEmailPopupComponent,
    ViewEmailPopupComponent,
    StudentImportViaExcelComponent,
    IndustryPartnerImportViaExcelComponent,
    StudentProfileComponent,
    PreviewFormsComponent,
    LoaderComponent,
    AutoResizeDirective
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgSelectModule,
    EditorModule,
    StudentFormModule,
    EmployerStudentFormModule,
    ViewProfileModule,
    ModalModule,
    NgxDnDModule,
    GooglePlaceModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    QuillModule.forRoot()
  ],
  exports: [
    UIModule,
    StudentImportViaExcelComponent,
    IndustryPartnerImportViaExcelComponent,
    StudentFormModule,
    EmployerStudentFormModule,
    ViewProfileModule,
    NgxDnDModule,
    GooglePlaceModule,
    QuillModule,
    AutoResizeDirective,
    ...SharedComponents,
  ],
  providers: [],
})
export class SharedModule { 
 
}
